import { render, staticRenderFns } from "./PolimixProductionOrder.vue?vue&type=template&id=09a66a00&"
import script from "./PolimixProductionOrder.vue?vue&type=script&lang=js&"
export * from "./PolimixProductionOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports